import { useTrialModalClosedLocalStorageKeyName } from 'features/forceTrial/useTrialModalClosedLocalStorageKeyName';

export const useSetModalIsClosedInLocalStorage = () => {
  const modalClosedAtKey = useTrialModalClosedLocalStorageKeyName();

  return () => {
    localStorage.setItem(modalClosedAtKey, new Date().valueOf().toString());
  };
};
